module.exports = __webpack_public_path__ + "img/consolidado-programa.4eed5cc6.png";